import { useEffect, useState } from "react";
import "../styles/AdminMessages.css";

function AdminMessages() {

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] =useState(true);
  const [error, setError] = useState("");

  useEffect(() => {

    async function loadMessages() {

      try {

        const response = await fetch(
          "/api/admin/messages"
        );

        if (!response.ok) {
          throw new Error("Failed to load messages.");
        }

        const data = await response.json();

        setMessages(data);

      } catch (err) {

        setError(err.message);

      } finally {

        setLoading(false);

      }

    }

    loadMessages();

  }, []);

  if (loading) {
    return (
      <div className="admin-loading">
        Loading messages...
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-error">
        {error}
      </div>
    );
  }

  return (

    <div className="admin-page">

      <div className="admin-header">

        <h1>
          EIFJB Admin Dashboard
        </h1>

        <p>
          Customer Contact Requests
        </p>

      </div>

      <div className="admin-stats">

        Total Messages:
        <strong> {messages.length}</strong>

      </div>

      {

        messages.length === 0 ?

        (

          <div className="empty-state">

            No contact requests yet.

          </div>

        )

        :

        (

          <div className="messages-grid">

            {

              messages.map((message) => (

                <div
                  className="message-card"
                  key={message.id}
                >

                  <div className="message-top">

                    <h2>

                      {message.full_name}

                    </h2>

                    <span>

                      #{message.id}

                    </span>

                  </div>

                  <div className="message-row">

                    <strong>Email</strong>

                    <p>{message.email}</p>

                  </div>

                  <div className="message-row">

                    <strong>Phone</strong>

                    <p>

                      {

                        message.phone ||

                        "-"

                      }

                    </p>

                  </div>

                  <div className="message-row">

                    <strong>Company</strong>

                    <p>

                      {

                        message.company_name ||

                        "-"

                      }

                    </p>

                  </div>

                  <div className="message-row">

                    <strong>Message</strong>

                    <p>

                      {

                        message.message ||

                        "-"

                      }

                    </p>

                  </div>

                  <div className="message-footer">

                    {

                      new Date(
                        message.createdAt
                      ).toLocaleString()

                    }

                  </div>

                </div>

              ))

            }

          </div>

        )

      }

    </div>

  );

}

export default AdminMessages;